import { ballArr, count, singleDouble, singleDoubleCnname, smallBig, continuity, continuityCnname, smallBigCnname, dragonTiger, fishCnname } from '../../../../helpers/resPatterns';
import dayjs from 'dayjs';

let treeChildren = index => {
  return [
    {
      align: 'center',
      title: '单',
      render: (h, { row }) => <span>{row[index] ? row[index].single : 0}</span>
    },
    {
      align: 'center',
      title: '双',
      render: (h, { row }) => <span>{row[index] ? row[index].double : 0}</span>
    },
    {
      align: 'center',
      title: '大',
      render: (h, { row }) => <span>{row[index] ? row[index].big : 0}</span>
    },
    {
      align: 'center',
      title: '小',
      render: (h, { row }) => <span>{row[index] ? row[index].small : 0}</span>
    }
  ];
};

const ssc = () => {
  let list = Vue => {
    let hasBallOpacity = (x, xIndex, data, dataIndex) => {
      let resClass = '';
      if (Vue.selectType === 0) {
        resClass += !~Vue.selectNumArr.indexOf(x) ? ' opacity' : '';
      }
      if (Vue.selectType === 1) {
        resClass += (Vue.selectValue != singleDouble(x)) != 0 ? ' opacity' : '';
      }
      if (Vue.selectType === 2) {
        resClass += (Vue.selectValue != smallBig(x, 9)) == 0 ? ' opacity' : '';
      }
      if (Vue.selectType === 3) {
        let lastStr = data[dataIndex - 1] ? data[dataIndex - 1].resultStr : '';
        let nextStr = data[dataIndex + 1] ? data[dataIndex + 1].resultStr : '';
        let lastArr = ballArr(lastStr);
        let nextArr = ballArr(nextStr);

        if (lastArr[xIndex] === x || nextArr[xIndex] === x) {
        } else {
          resClass += ' opacity';
        }
      }
      return resClass;
    };
    return [
      {
        title: '期数',
        align: 'center',
        key: 'issueId'
      },
      {
        renderHeader: (h, params) => {
          return (
            <div class="showBallHandle">
              <span on-click={_ => (Vue.tableShowBallType = 0)} class={Vue.tableShowBallType == 0 && 'active'}>
                显示号码
              </span>
              <span on-click={_ => (Vue.tableShowBallType = 1)} class={Vue.tableShowBallType == 1 && 'active'}>
                显示大小
              </span>
              <span on-click={_ => (Vue.tableShowBallType = 2)} class={Vue.tableShowBallType == 2 && 'active'}>
                显示单双
              </span>
            </div>
          );
        },
        width: 352,
        align: 'center',
        render: (h, { row, index }) => {
          let arr = ballArr(row.resultStr);
          let boxClassName = 'ball';
          if (Vue.tableShowBallType == 0) {
            boxClassName += ' num';
            arr = arr.map((x, i) => {
              let className = '';
              className += hasBallOpacity(x, i, Vue.dataSource, index);
              return { value: x, className };
            });
          }
          if (Vue.tableShowBallType == 1) {
            boxClassName += ' smallBig';
            arr = arr.map((x, i) => {
              let className = smallBig(x, 9) == 0 ? 'small' : 'big';
              className += hasBallOpacity(x, i, Vue.dataSource, index);
              return { value: '', className };
            });
          }
          if (Vue.tableShowBallType == 2) {
            boxClassName += ' singleDouble';
            arr = arr.map((x, i) => {
              let className = singleDouble(x) == 0 ? 'single' : 'double';
              className += hasBallOpacity(x, i, Vue.dataSource, index);
              return { value: '', className };
            });
          }

          return (
            <div class={boxClassName}>
              {arr.map((x, i) => {
                return (
                  <span class={x.className} key={i}>
                    {x.value}
                  </span>
                );
              })}
            </div>
          );
        }
      },
      {
        title: '总和',
        align: 'center',
        render: (h, { row }) => {
          let arr = ballArr(row.resultStr);
          return (
            <div class="insideTableTd">
              <p class="count brr">{count(arr)}</p>
              <p class="singleDouble brr">{singleDouble(count(arr)) == 0 ? <span class="blue">单</span> : <span class="red">双</span>}</p>
              <p class="smallBig">{smallBig(count(arr), 45) == 0 ? <span class="blue">小</span> : <span class="red">大</span>}</p>
            </div>
          );
        }
      },
      {
        title: '1-5龙虎',
        width: 60,
        align: 'center',
        render: (h, { row }) => {
          let arr = ballArr(row.resultStr);
          let res = dragonTiger(arr[0], arr[4]);
          if (res == 0) {
            return <span class="red">龙</span>;
          } else if (res == 1) {
            return <span class="blue">虎</span>;
          } else {
            return <span class="green">和</span>;
          }
        }
      },
      {
        title: '1-5球大小',
        align: 'center',
        render: (h, { row }) => {
          let arr = ballArr(row.resultStr);
          return (
            <div class="insideTableTd">
              {arr.map((x, i) => {
                return smallBig(x, 9) == 0 ? <p class="brr blue">小</p> : <p class="brr red">大</p>;
              })}
            </div>
          );
        }
      },
      {
        title: '1-5球单双',
        align: 'center',
        render: (h, { row }) => {
          let arr = ballArr(row.resultStr);
          return (
            <div class="insideTableTd">
              {arr.map((x, i) => {
                return singleDouble(x) == 0 ? <p class="brr blue">单</p> : <p class="brr red">双</p>;
              })}
            </div>
          );
        }
      },
      {
        title: '前三',
        align: 'center',
        width: 60,
        render: (h, { row }) => {
          let arr = ballArr(row.resultStr);
          let continuityres = continuity([arr[0], arr[1], arr[2]]);
          return <span class={continuityres < 3 ? 'blue' : 'red'}>{continuityCnname[continuityres]}</span>;
        }
      },
      {
        title: '中三',
        width: 60,
        align: 'center',
        render: (h, { row }) => {
          let arr = ballArr(row.resultStr);
          let continuityres = continuity([arr[1], arr[2], arr[3]]);

          return <span class={continuityres < 3 ? 'blue' : 'red'}>{continuityCnname[continuityres]}</span>;
        }
      },
      {
        title: '后三',
        width: 60,
        align: 'center',
        render: (h, { row }) => {
          let arr = ballArr(row.resultStr);
          let continuityres = continuity([arr[2], arr[3], arr[4]]);

          return <span class={continuityres < 3 ? 'blue' : 'red'}>{continuityCnname[continuityres]}</span>;
        }
      }
    ];
  };

  let doubleStatisColumns1 = [
    {
      title: '号码',
      width: 176,
      align: 'center',
      key: 'title'
    },
    {
      title: '0',
      align: 'center',
      key: '0'
    },
    {
      title: '1',
      align: 'center',
      key: '1'
    },
    {
      title: '2',
      align: 'center',
      key: '2'
    },
    {
      title: '3',
      align: 'center',
      key: '3'
    },
    {
      title: '4',
      align: 'center',
      key: '4'
    },
    {
      title: '5',
      align: 'center',
      key: '5'
    },
    {
      title: '6',
      align: 'center',
      key: '6'
    },
    {
      title: '7',
      align: 'center',
      key: '7'
    },
    {
      title: '8',
      align: 'center',
      key: '8'
    },
    {
      title: '9',
      align: 'center',
      key: '9'
    }
  ];

  let doubleStatisColumns2 = [
    {
      title: '球次',
      key: 'title',
      align: 'center',
      width: 176
    },
    {
      title: '总和',
      align: 'center',
      children: treeChildren('count')
    },
    {
      title: '第一球',
      align: 'center',
      children: treeChildren(0)
    },
    {
      title: '第二球',
      align: 'center',
      children: treeChildren(1)
    },
    {
      title: '第三球',
      align: 'center',
      children: treeChildren(2)
    },
    {
      title: '第四球',
      align: 'center',
      children: treeChildren(3)
    },
    {
      title: '第五球',
      align: 'center',
      children: treeChildren(4)
    }
  ];

  return { list, doubleStatisColumns1, doubleStatisColumns2 };
};

export default ssc;



// WEBPACK FOOTER //
// ./src/pages/Trend/Zonghefenxi/columns/ssc.js